var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0007 5.33301C17.2731 5.33301 5.33398 17.2721 5.33398 31.9997C5.33398 46.7273 17.2731 58.6663 32.0007 58.6663C46.7282 58.6663 58.6673 46.7273 58.6673 31.9997C58.6673 17.2721 46.7282 5.33301 32.0007 5.33301ZM30.6556 21.9115C30.7664 21.3908 31.1805 21.0306 31.6456 20.9853C31.8007 20.9703 31.9618 20.9888 32.1191 21.0494C33.0613 21.41 34.2046 22.2366 34.2046 24.1251C34.2046 26.1929 33.1027 28.9686 33.1027 28.9686H40.8162C42.0283 28.9686 43.02 30.0224 43.02 31.3104V32.4126C43.02 32.8927 42.9243 33.3674 42.7403 33.8053L39.4323 41.7154C39.1006 42.5081 38.3614 43.0189 37.5448 43.0189H28.695C27.4773 43.0189 26.4911 41.971 26.4911 40.6772V29.8674C26.4911 29.289 26.6924 28.7306 27.0571 28.3009L30.0444 24.7746L30.6556 21.9115ZM20.9815 30.7249C20.9815 29.7555 21.722 28.9686 22.6344 28.9686C23.5468 28.9686 24.2873 29.7555 24.2873 30.7249V41.2626C24.2873 42.2321 23.5468 43.0189 22.6344 43.0189C21.722 43.0189 20.9815 42.2321 20.9815 41.2626V30.7249Z",
    fill: "#02A153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.c76800a522e75f145aadde0d2bfa9112.svg";
export { ForwardRef as ReactComponent };